import React, { useEffect, useState } from 'react';
import { DateInput, Filter, maxLength, minLength, SearchInput, SelectInput, useNotify } from 'react-admin';
import { deviseFiltre, has_role, json, typeCampagne } from '../references.js';
//import moment from 'moment'

const FiltreEncaissement=(props)=>{

    const [usersAyantFaitEncaissement, setUsersAyantFaitEncaissement] = useState();
    const {permissions}=props;
    const notify = useNotify();

    useEffect(() => {
        if(has_role(permissions,'ROLE_MANAGER')){
            fetch(process.env.REACT_APP_URL+'/caisse/getListUsersAyantFaitEncaissement', { method: 'GET',
                    headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json;charset=UTF-8',
                            "Authorization": "Bearer "+ localStorage.getItem('token')
                    }
                }
            ).then(json)
            .then((data) => {
                //console.log(data)
                setUsersAyantFaitEncaissement(data);
            }).catch((e) => {
                notify("Erreur lors du processus de récupération de la liste des agents m'ayant envoyé un versement !", 'warning')
            });
        }
    }, []);

    return (
        <Filter {...props} >
            <SearchInput source="code" alwaysOn  validate={[minLength(5),maxLength(6)]} />
            <DateInput source="start_date" label="Date début"  alwaysOn />
            <DateInput source="end_date" label="Date fin"  alwaysOn />
          
            <SelectInput
                source="devise"
                label="Devise" 
                choices={deviseFiltre}
            />

            <SelectInput
                source="camp_type"
                label="Type campagne" 
                choices={typeCampagne}
            />
            {has_role(permissions,'ROLE_MANAGER') ? 
                <SelectInput
                    source="agent_id"
                    label="Agent" 
                    choices={usersAyantFaitEncaissement}
                />:null
            }
        </Filter>
    );

    
}

export default FiltreEncaissement;